import {Checkbox, Column, HeaderColumn, Row} from '@vidazoo/ui-kit';
import {observer} from 'mobx-react';
import {useChartsListContext} from '../context/ChartsListContext';
import theme from '../view/theme.module.scss';
import {ReactComponent as SearchIcon} from '../assets/search-small.svg';
import {ReactComponent as ClearIcon} from '../assets/cancel-small.svg';
import {ReactComponent as IncreaseIcon} from '../assets/increase-small.svg';
import {ReactComponent as DecreaseIcon} from '../assets/decrease-small.svg';

const headerIcons = {'icon-search': SearchIcon, 'icon-cancel-small': ClearIcon,
    'icon-increase-small': IncreaseIcon, 'icon-decrease-small': DecreaseIcon};
const renderHeaderIcon = (name: string, size: number) => {
    const SvgIcon = headerIcons[name];
    return <SvgIcon aria-hidden="true" focusable="false" style={{width: `${size}rem`, height: `${size}rem`}}/>;
};

export const ChartsTableHeader = observer(function ChartsTableHeader() {
    const {model, tableRowSelectionHook} = useChartsListContext();
    const {isAllSelected, toggleAllItems} = tableRowSelectionHook;
    return <Row>
        <Column colKey="checkbox" className={theme.checkboxHeader} data-header-column="true">
            <Checkbox aria-label="Select all charts" disabled={model.isLoading} checked={isAllSelected} onChange={toggleAllItems}/>
        </Column>
        {['name', 'type', 'created', 'updated', 'isActive', 'actions'].map(key =>
            <HeaderColumn key={key} appearance="classic" colKey={key}
                renderIcon={renderHeaderIcon}
                defaultSortDirection={key === 'name' && !model.sortedColumnsOrder.length ? 1 : undefined}/>) }
    </Row>;
});
